import { cn } from '@/lib/utils';
import type { ClientStatus } from '@/lib/clientStatus';
import { statusConfig } from '@/lib/clientStatus';

type Props = {
  status: ClientStatus;
  label?: string;
  size?: 'sm' | 'md';
};

export function StatusBadge({ status, label, size = 'sm' }: Props) {
  const { label: defaultLabel, cls } = statusConfig[status];
  return (
    <span
      className={cn(
        'rounded-lg border font-medium',
        size === 'sm' ? 'text-xs px-2 py-0.5' : 'text-xs px-2.5 py-1',
        cls
      )}
    >
      {label ?? defaultLabel}
    </span>
  );
}
